module.exports = __webpack_public_path__ + "img/service.e103d74f.png";